import Coordinate from "./Coordinate";

export default class ControlPoint extends Coordinate {
    size = 8;
    hitSize = 20;

    constructor(provider, absX, absY, segment, guideAnchor = 'both') {
        super(provider, absX, absY);
        this.segment = segment;
        this.guideAnchor = guideAnchor; // 'start', 'end', or 'both'
        this.xRatio = 0;
        this.yRatio = 0;
    }

    get parent() {
        return this.segment.parent;
    }

    calculateRatio() {
        this.xRatio = (this.absX - this.parent.absMinX) / this.parent.absWidth;
        this.yRatio = (this.absY - this.parent.absMinY) / this.parent.absHeight;
    }

    display(g) {
        g.stroke(0, 100, 200);
        g.strokeWeight(1);
        g.fill(255, 255, 255, 200);

        // Guide lines
        if (this.guideAnchor !== 'end') {
            g.line(this.currentX, this.currentY, this.segment.start.currentX, this.segment.start.currentY);
        }
        if (this.guideAnchor !== 'start') {
            g.line(this.currentX, this.currentY, this.segment.end.currentX, this.segment.end.currentY);
        }

        // Diamond shape
        let s = this.size / 2;
        g.quad(
            this.currentX, this.currentY - s,
            this.currentX + s, this.currentY,
            this.currentX, this.currentY + s,
            this.currentX - s, this.currentY,
        );
    }

    hovered() {
        let d = this.p.dist(this.currentX, this.currentY, this.view.currentX, this.view.currentY);
        return d < this.hitSize / 2;
    }

    drag(dx, dy) {
        if (dx == 0 && dy == 0) {
            return;
        }
        super.move(dx, dy);
        this.calculateRatio();
        this.parent.updateSupportCoordinates();
    }
}
